import {ADDITIONAL_PRODUCTS_MODULES} from './catalog/additional_products';
import {trackOnce} from './track.frontevents.utils';

const formatSuffix = (suffix = '') => suffix.length > 0 ? `:${suffix}` : '';

const getLabelFormatter = (module) => (policy = '') => `${module}${formatSuffix(policy)}`;

export const additionalProductsCatalog = Object.keys(ADDITIONAL_PRODUCTS_MODULES).reduce((result, key) => ({
    ...result,
    [key]: {label: getLabelFormatter(ADDITIONAL_PRODUCTS_MODULES[key])},
}), {});

export const trackOncePerPolicy = trackOnce;
